import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import TextareaAutosize from 'react-textarea-autosize';
import PAlert from '../PAlert';
import useDidMountEffect from '../../utils/useDidMountEffect';

import './style.scss';

const ReportPost = ({ show, setShow, post }) => {
    const [description, setDescription] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState(false);
    const [alertBody, setAlertBody] = useState('');

    const userInformation = JSON.parse(localStorage.getItem('user'));

    const handleClose = () => {
        setShow(false);
    };

    const handleChange = (e) => {
        setDescription(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        await axios.post('/api/report-post', {
            post_id: post.id,
            description
        })
            .then(response => {
                setAlertTitle(`Thank you <span class="report-post__tyname">${userInformation.login}</span>`);
                setAlertBody(`Your report has been sent to admin!`);
                setShowAlert(true);
                setIsLoading(false);
            }).
            catch(error => {
                let errorMessage = '';

                setAlertTitle('Sending of report failed');

                if (error.response.status === 422) {
                    errorMessage = error.response.data.errors['description'][0];
                } else {
                    errorMessage = `Please click <a href="https://priva.uvdesk.com/en/" target="_blank">here</a> to contact support.`;
                }

                setAlertBody(errorMessage);
                setShowAlert(true);
                setIsLoading(false);
            });
    };

    useDidMountEffect(() => {
        if (!showAlert) {
            setShow(false);
        }
    }, [showAlert]);

    return (
        <>
            <PAlert show={showAlert} setShow={setShowAlert} title={alertTitle} body={alertBody} isHtmlTitle={true} />
            {!showAlert && <Modal className="report-post" show={show} onHide={handleClose} centered>
                <Modal.Body>
                    <h4 className="mb-3" align="center">Report post?</h4>
                    <TextareaAutosize
                        rows={5}
                        name="report-description"
                        placeholder="Provide details of your report"
                        onChange={handleChange}
                        value={description}
                        minRows={5}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                    <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
                        {isLoading ? 'Submitting...' : 'Submit'}
                    </Button>
                </Modal.Footer>
            </Modal>
            }
        </>
    );
};

export default ReportPost;